import { render, staticRenderFns } from "./SendServiceComponent.vue?vue&type=template&id=0b684ef0&scoped=true&"
import script from "./SendServiceComponent.vue?vue&type=script&lang=js&"
export * from "./SendServiceComponent.vue?vue&type=script&lang=js&"
import style0 from "./SendServiceComponent.vue?vue&type=style&index=0&id=0b684ef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b684ef0",
  null
  
)

export default component.exports